import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { SketchPicker } from "react-color";
import Card from "@material-ui/core/Card";
import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import LinearProgress from "@material-ui/core/LinearProgress";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Sidebar from "../../components/Sidebar";
import { AuthContext } from "../../context/AuthContext";

const useStyle = makeStyles({
  fieldWrapper: {
    display: "flex",
    marginBottom: 30,
  },
  fieldName: {
    flexGrow: 1,
    marginTop: 11,
    width: 100,
  },
  fieldInput: {
    flexGrow: 3,
    width: 200,
  },
  input: {
    padding: "5px",
    height: 45,
    borderRadius: 15,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 15,
  },
  margin: {
    marginBottom: 20,
  },
  textarea: {
    borderRadius: 15,
  },
  buttonStyle: {
    padding: " 10px 30px",
    fontSize: 14,
    borderRadius: "25px",
    marginLeft: 20,
  },
  buttonWeraper: {
    marginTop: 25,
    float: "right",
  },
  styleCancel: {
    color: "#999",
  },
  padding: {
    padding: 30,
  },
  label: {
    backgroundColor: "indigo",
    color: "white",
    padding: "0.5rem",
    borderRadius: "0.3rem",
    cursor: "pointer",
    marginTop: "1rem",
  },
});

const CreateShopPromos = () => {
  const classes = useStyle();
  const history = useHistory();
  const [title, set_title] = useState("");
  const [details, set_details] = useState("");
  const [submitType, setSubmitType] = useState("");
  const [app_for, set_app_for] = useState("");
  const [link, set_link] = useState("");
  const [attachment, set_attachment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [fileName, setFileName] = useState("");
  const { auth, logout } = useContext(AuthContext);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      if (attachment) {
        const imagedata = attachment;
        data.append("attachment", imagedata);
      }
      data.append("title", title);
      data.append("details", details);
      if (app_for.length > 0) {
        data.append("app_for", app_for);
      }
      data.append("link", link);
      let res = await axios({
        url: "api/shop-promos",
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
          type: "formData",
        },
      });
      console.log(res);

      if (res.data.code === 200) {
        Swal.fire({
          icon: "success",
          title: "Succesfully Saved",
          showConfirmButton: false,
          timer: 1000,
        });
        if (submitType === "addAnother") {
          set_title("");
          set_details("");
          set_app_for("");
          set_attachment(null);
          set_link("");
          setFileName("");
          setRefresh(!refresh);
        } else if (submitType === "add") {
          history.push("/shop-promo-list");
        }
      } else {
        Swal.fire({
          icon: "warning",
          title: res.data.messages,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: `${error.response.data.messages.toString()}`,
        showConfirmButton: false,
        timer: 2000,
      });
    }
    setLoading(false);
  };

  const handleCancel = () => {
    history.push("/shop-promo-list");
  };

  const imageButton = () => {
    const actualBtn = document.getElementById("actual-btn");

    const fileChosen = document.getElementById("file-chosen");

    actualBtn.addEventListener("change", function () {
      fileChosen.textContent = this.files[0].name;
      setFileName(this.files[0].name);
    });
  };


  useEffect(() => {
    imageButton();
  }, [refresh]);

  return (
    <div className="wrapper">
      <Sidebar />
      <div className="wrapper-inner">
        <form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item md={10} lg={8}>
              <Typography variant="h4" className={classes.margin}>
                Create Shop Promos
              </Typography>
              <Card>
                <CardContent className={classes.padding}>
                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Title</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        required
                        placeholder="E.g. Buy One. Get One Free"
                        variant="outlined"
                        fullWidth
                        value={title}
                        onChange={(e) => set_title(e.target.value)}
                        InputProps={{
                          className: classes.input,
                        }}
                      />
                    </div>
                  </div>
                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Bannar</Typography>
                    </div>

                    <div className={classes.fieldInput}>
                      <input
                        type="file"
                        id="actual-btn"
                        accept="image/png, image/jpeg"
                        hidden
                        onChange={(e) => set_attachment(e.target.files[0])}
                        name="attachment"
                      />
                      <label htmlFor="actual-btn">
                        <Button
                          variant="contained"
                          color="primary"
                          component="span"
                          className={classes.buttonStyle}
                          style={{ marginLeft: "-0px" }}
                        >
                          Choose file
                        </Button>
                      </label>
                      <span id="file-chosen" style={{ marginLeft: 15 }}>
                        {fileName ? fileName : "No file chosen"}
                      </span>
                    </div>
                  </div>
                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Details</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        required
                        variant="outlined"
                        placeholder="Details"
                        multiline
                        rcurrenciesows={7}
                        rows={5}
                        fullWidth
                        value={details}
                        onChange={(e) => set_details(e.target.value)}
                        InputProps={{
                          className: classes.textarea,
                        }}
                      />
                    </div>
                  </div>

                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Link</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        required
                        placeholder="Link"
                        variant="outlined"
                        placeholder="https://example.com"
                        fullWidth
                        type="url"
                        value={link}
                        onChange={(e) => set_link(e.target.value)}
                        InputProps={{
                          className: classes.input,
                        }}
                      />
                    </div>
                  </div>

                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">App for</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        id="outlined-select-currency"
                        select
                        value={app_for}
                        onChange={(e) => set_app_for(e.target.value)}
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          className: classes.select,
                        }}
                      >
                        <MenuItem value="">All</MenuItem>

                        <MenuItem value="personal">Personal</MenuItem>
                      </TextField>
                    </div>
                  </div>

                </CardContent>
              </Card>
              {loading ? (
                <LinearProgress style={{ marginTop: 20 }} />
              ) : (
                <div className={classes.buttonWeraper}>
                  <Button
                    onClick={handleCancel}
                    className={classes.styleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    type="submit"
                    className={classes.buttonStyle}
                    onClick={(e) => setSubmitType("addAnother")}
                  >
                    Create & Add Another
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                    className={classes.buttonStyle}
                    onClick={(e) => setSubmitType("add")}
                  >
                    Create Shop Promos
                  </Button>
                </div>
              )}
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
};

export default CreateShopPromos;
